import { useEffect, useRef, useState } from 'react'
import Invoices from '../../components/Disbursment/Invoices';
import { useLocation, useNavigate } from 'react-router-dom';
import { get_disbursment_invoices} from '../../helper/Api';
import {
    GET_D_INVOICES_START,
    GET_D_INVOICES_SUCCESS,
    GET_D_INVOICES_FAIL
} from '../../RTK/Slices/DisbursmentInvoiceSlice';
import { useDispatch, useSelector } from 'react-redux';
import SubHeader from '../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import CreateButton from '../../components/Tools/CreateButton';
import MainFilter from '../../components/Tools/MainFilter';
import DashboardFilter from '../Dashboard/components/DashboardFilter';
import { toast } from 'react-toastify';
import Spinner from '../../components/Tools/spinner';


const InvoiceList = () => {
    const { financialYears, authData } = useSelector((state) => state.authData);
    const { loading } = useSelector((state) => state.disbursment_invoiceData);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [fyId, setFyId] = useState(fyIdRef.current);

    const [filterPayload, setFilterPayload] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
        district_id: "",
        district_name: "",
    });

    const [filterApplied, setFilterApplied] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
        district_id: "",
        district_name: "",
    });

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleInput = async (e) => {
        const { name, value } = e.target;
        setFilterPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const bootList = async () => {
        setFilterApplied(filterPayload);
        setOpen(false);
    };

    const handleFilterRemove = async (name) => {
        const newPayload = {
            ...filterPayload,
            [name]: "",
        };
        if (name === "district_id") {
            newPayload.district_name = "";
        }
        setFilterPayload(newPayload);
        setFilterApplied(newPayload);
    };

    const getDefaultDateRange = (fyIdValue) => {
        const selectedFy = fyList?.find((fy) => String(fy?.id) === String(fyIdValue));
        if (!selectedFy?.start_year || !selectedFy?.end_year) {
            return { from_date: "", to_date: "" };
        }
        return {
            from_date: `${selectedFy.start_year}-04-01`,
            to_date: `${selectedFy.end_year}-03-31`,
        };
    };


    function structureData(data) {
        const sanctionMap = new Map();

        data.forEach(item => {
            const sanctionId = item.sanction_order_id;
            const voucherId = item.voucher_id;
            const invoiceAmount = parseFloat(item.invoice_value || 0);

            // Create sanction order if not exists
            if (!sanctionMap.has(sanctionId)) {
            sanctionMap.set(sanctionId, {
                sanction_order_id: sanctionId,
                sanction_order_no: item.sanction_order_no,
                sanction_order_date: item.sanction_order_date,
                sanction_order_url: item.sanction_order,
                vouchers: new Map(),
                sanction_amount: 0
            });
            }

            const sanction = sanctionMap.get(sanctionId);

            // Create voucher if not exists
            if (!sanction.vouchers.has(voucherId)) {
            sanction.vouchers.set(voucherId, {
                voucher_id: voucherId,
                voucher_no: item.voucher_no,
                voucher_date: item.voucher_date,
                voucher_url: item.voucher,
                invoices: [],
                voucher_amount: 0
            });
            }

            const invoice = { ...item };

            // Push invoice and add to amounts
            const voucher = sanction.vouchers.get(voucherId);
            voucher.invoices.push(invoice);
            voucher.voucher_amount += invoiceAmount;
            sanction.sanction_amount += invoiceAmount;
        });

        // Convert nested maps to arrays
        const result = [];
        sanctionMap.forEach(sanction => {
            sanction.vouchers = Array.from(sanction.vouchers.values());
            result.push(sanction);
        });

        return result;
    }




    const fetchInvoices = async (payload = {}) => {
        dispatch(GET_D_INVOICES_START());
        try {
            const { from_date, to_date } = getDefaultDateRange(fyIdRef.current);
            const invoices_response = await get_disbursment_invoices({
                department_id: filterApplied?.department_id || authData?.user?.department_id || '',
                from: payload?.from_date ?? from_date,
                to: payload?.to_date ?? to_date,
                dateColumn: 'voucher_date',
                fy_id: payload?.fy_id ?? fyIdRef.current,
                district_id: filterApplied?.district_id || '',
            });
            if (invoices_response.data.status) {
                dispatch(GET_D_INVOICES_SUCCESS(invoices_response.data.list))
                setData(structureData(invoices_response.data.list))
            } else {
                dispatch(GET_D_INVOICES_FAIL(invoices_response.data.message))
            }
        } catch (error) {
            const data = error?.response?.data;
            const apiMessage =
                (typeof data === "string" && data) ||
                data?.message ||
                data?.error ||
                (Array.isArray(data?.errors) && data.errors.join(", ")) ||
                error?.message ||
                "Something went wrong.";
            toast.error(apiMessage, { position: toast.POSITION.TOP_CENTER });
            dispatch(GET_D_INVOICES_FAIL(apiMessage))
        }
    }

    useEffect(() => {
        fetchInvoices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fyId, filterApplied.department_id, filterApplied.district_id, fyList?.length]);

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
        setFyId(fyIdRef.current);
    }

    return (
        <div>
            {loading && <Spinner />}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-2'>
                <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>Vendor Payment</h4>
                        <CustomBreadcrumbs linksArray={[]} title="Vendor Payment"/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            {authData.user.user_type === 'l1' && (
                                <button type="button" className="navigation_button" onClick={() => navigate("/draft-sanction-orders")}>
                                    <span className="fs-14px">Draft Sanction Orders</span>
                                </button>
                            )}
                            <button type="button" className="navigation_button" onClick={() => navigate("/fund-invoice-list?pending=false")}>
                                <span className="fs-14px">Invoice Approval</span>
                            </button>
                        </div>
                    </div>
                </div>
                <DashboardFilter
                    openFilterModal={setOpen}
                    filterPayload={filterApplied}
                    handleFilterRemove={handleFilterRemove}
                    isTierRemovalRequired={true}
                />
                <Invoices data={data} approval={false}/>
                { authData.user.user_type === 'l1' && <CreateButton title={"Add Sanction Order"} url={"/add-sanction-order"}/> }
                <MainFilter
                    open={open}
                    handleClose={handleClose}
                    handleInput={handleInput}
                    handleOpen={handleOpen}
                    handleFilterClick={bootList}
                    filterPayload={filterPayload}
                    setConsolidate={setFilterPayload}
                    type="Vendor Payment"
                />
            </div>
        </div>
    )
}
export default InvoiceList
